import { dataHooks } from '../../../../libs/dataHooks';

export const widgetDataHooks = dataHooks<{
  details;
  list;
}>('widget');
